(function () {
  var root = document.documentElement;
  var buttons = document.querySelectorAll('[data-mode-option]');
  if (!buttons.length) return;

  function applyMode(mode, persist) {
    if (mode === 'dog') {
      root.setAttribute('data-mode', 'dog');
    } else {
      root.removeAttribute('data-mode');
    }

    buttons.forEach(function (btn) {
      var isActive = btn.getAttribute('data-mode-option') === mode;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    if (persist) {
      try {
        localStorage.setItem('pawfect-mode', mode);
      } catch (e) {}
    }
  }

  var saved = 'cat';
  try {
    saved = localStorage.getItem('pawfect-mode') || 'cat';
  } catch (e) {}
  applyMode(saved, false);

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      applyMode(btn.getAttribute('data-mode-option'), true);
    });
  });
})();
